// extracted by mini-css-extract-plugin
module.exports = {"item":"_2dB0tM_B1yo7v7kDx7tfWo","mutating":"_1cd9x6onmj574CU2E3I7-V","content":"_27QJI1yKXNtZufUVvtyZ5U","description":"_2TcPfiNJGc4ZJawzsArStM"};